import { supabase } from "@/utils/supabase";

const FUNCTIONS_URL = `${process.env.VUE_APP_SUPABASE_URL}/functions/v1`;

// Edge Function 호출 (JWT 인증) — ChzzkOAuthApi.callFn과 동일 패턴.
//  트위치는 무토큰 직결(익명 IRC)이지만, platform_oauth write는 Edge(service role) 단일 소유라
//  채널 저장/해제도 signaling 경유(치지직과 대칭).
async function callFn(path, body) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) throw new Error("E_NOT_LOGGED_IN");

  const res = await fetch(`${FUNCTIONS_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: process.env.VUE_APP_SUPABASE_KEY,
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(body || {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw Object.assign(new Error(json.message || "E_REQUEST_FAILED"), { detail: json });
  }
  return json;
}

export default {
  // 채널명 저장 + enabled on. (channelName = 트위치 로그인명)
  async connect(channelName) {
    return await callFn("/signaling/twitch/connect", { channelName });
  },
  // 연동 해제 — 행 삭제 + enabled off. (폐기할 토큰 없음)
  async disconnect() {
    return await callFn("/signaling/twitch/disconnect");
  },
};
